// extracted by mini-css-extract-plugin
export var videoPlayer = "tP49Y";